<template>
    <div class="o-keyboard keyboard">
        <div class="keyboard__container">
            <div 
                class="keyboard__row"
                v-for="(row, index) in characters"
                :key="index"
            >
                <AKeyboardKey
                    v-for="(key, index) in row"
                    :key="index"
                    :item="key"
                    @onClick="onKeyCLick"
                />
            </div>
        </div>
        <div class="keyboard__bottom-block">
            <AKeyboardKey
                item="123"
                @onClick="changeView"
            />
            <AKeyboardKey 
                class="keyboard__space"
                item=" "
                @onClick="onKeyCLick"
            >
                <svg-icon
                    original
                    name="icons/space"
                    class="keyboard__space-icon"
                />
            </AKeyboardKey>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AKeyboardKey from '../../atoms/a-keyboard-key/a-keyboard-key';

import { characters } from './o-keyboard-characters';

export default {
    name: "o-keyboard",
    data() {
        return {
            letters: true
        }
    },
    components: {
        AKeyboardKey
    },
    computed: {
        ...mapGetters([
            'getActiveLocale'
        ]),
        characters() {
            if (this.letters) {
                return characters[this.getActiveLocale].letters;
            }
            return characters[this.getActiveLocale].symbols;
        }
    },
    methods: {
        changeView() {
            this.letters = !this.letters;
        },
        onKeyCLick(data) {
            this.$emit('onKeyCLick', data);
        }
    }
}
</script>

<style lang="scss">
@import "o-keyboard";
</style>
